/**
 * Debug utility for conditional logging in development mode only
 */

export const debug = {
  log: (message: string, data?: any) => {
    if (import.meta.env.DEV) {
      console.log(message, data);
    }
  },

  warn: (message: string, data?: any) => {
    if (import.meta.env.DEV) {
      console.warn(message, data);
    }
  },

  error: (message: string, data?: any) => {
    if (import.meta.env.DEV) {
      console.error(message, data);
    }
  },

  info: (message: string, data?: any) => {
    if (import.meta.env.DEV) {
      console.info(message, data);
    }
  }
};

// Legacy support - can be used as debug.log or just debug()
export default function debugLog(message: string, data?: any) {
  debug.log(message, data);
} 